import { render, staticRenderFns } from "./ChooseNationalityMulti.vue?vue&type=template&id=2a8a806b&scoped=true"
import script from "./ChooseNationalityMulti.vue?vue&type=script&lang=js"
export * from "./ChooseNationalityMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a806b",
  null
  
)

export default component.exports